const isResponseMeta = (headers: Headers): boolean => {
  return Boolean(
    headers.get('X-Page') && headers.get('X-Total') && headers.get('X-Total-Pages') && headers.get('X-Per-Page'),
  )
}

export const getResponseMeta = (headers: Headers) => {
  if (!isResponseMeta(headers)) {
    return {
      page: 1,
      total: 0,
      totalPages: 1,
      perPage: 1,
    }
  }

  return {
    page: headers.get('X-Page') ? Number(headers.get('X-Page')) : 1,
    total: headers.get('X-Total') ? Number(headers.get('X-Total')) : 0,
    totalPages: headers.get('X-Total-Pages') ? Number(headers.get('X-Total-Pages')) : 1,
    perPage: headers.get('X-Per-Page') ? Number(headers.get('X-Per-Page')) : 1,
  }
}
